<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать комплексную статистику':'Добавить комплексную статистику'}}
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-tabs slot="extension" v-model="tab" slider-color="primary" color="panel" dark>
        <v-tab href="#params">Параметры</v-tab>
        <v-tab href="#indicators">Показатели</v-tab>
        <v-tab href="#scope">Область видимости</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        
        <v-tab-item class="mt-2" value="params">
          <v-text-field v-model="statistic.name" label="Название"></v-text-field>
          
          <div class="mb-3">
            <label class="v-label theme--light" style="font-size: 13px">Описание</label>
            <dantser-editor v-model="statistic.description" :init="config" :api-key="apiKey"></dantser-editor>
          </div>
          
          <v-layout row wrap align-end>
            <v-flex xs12 sm6>
              <v-select :items="periods" label="Период по умолчанию" v-model="statistic.period_type" no-data-text="Значения отсутствуют"></v-select>
            </v-flex>
            <v-flex xs12 sm6 :class="{'pl-3':$vuetify.breakpoint.smAndUp}">
              <v-checkbox label="Перевернутый график" v-model="statistic.invert_chart"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-select :items="sets" label="Добавить в наборы" v-model="statistic.sets" item-text="name" item-value="id" multiple no-data-text="Нет доступных наборов"></v-select>
        </v-tab-item>
        
        <v-tab-item class="mt-2" value="indicators">
          <statistic-select :labels="all_indicators" :value="statistic.labels"></statistic-select>
        </v-tab-item>
        
        <v-tab-item class="mt-2" value="scope">
          <dantser-scope :treedata="treedata" v-model="statistic.scope"></dantser-scope>
        </v-tab-item>
        
      </v-tabs-items>
    </v-card-text>
  
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submitData" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  const uuidRegexpPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  
  import StatisticSelect from '../../Common/StatisticSelect'
  import { Swatches } from 'vue-color'
  import {mapGetters, mapState} from 'vuex'
  import entities from '@/mixins/entities/old'

  export default {
    name : 'StatisticForm',
  
    mixins: [entities],
    
    components:{
      'swatches-picker': Swatches,
      StatisticSelect
    },
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          period_type: 1,
          invert_chart: false,
          scope: [],
          labels: [],
          sets: []
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      ...mapState('analytics', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
      ...mapGetters('analytics_old/sets', ['sets']),
      ...mapGetters('analytics_old/indicators', ['indicators']),
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      all_indicators(){
        return [
          {
            id: 1,
            name: 'Мои статистики',
            children: this.indicators.my,
            expanded: true
          },
          {
            id: 2,
            name: 'Доступные мне',
            children: this.indicators.other,
            expanded: true
          }
        ]
      }
    },
  
    mounted(){
      this.statistic = JSON.parse(JSON.stringify(this.data))
      this.getTree()
      this.$store.dispatch('analytics_old/indicators/list')
      if(this.editMode) this.getStatisticData()
    },
    
    data() {
      return {
        statistic: {},
        tab: null,
        periods: [
          { value: 0, text: 'Час' },
          { value: 1, text: 'День' },
          { value: 2, text: 'Неделя' },
          { value: 3, text: 'Месяц' }
        ],
        treedata: [],
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        },
      }
    },
    
    methods : {
      getStatisticData(){
        this.$store.dispatch('analytics_old/statistics/getParams', this.statistic.id ).then( response => {
          this.$set(this.statistic, 'labels', response.labels)
          this.$set(this.statistic, 'scope', response.scope)
          this.$set(this.statistic, 'sets', response.sets)
          
          this.convertOutputSettings(this.statistic.labels)
          
          let posts = []
          let containers = []
          this.statistic.scope.map( item => {
            if (item.element_type==="container"){
              let container = this.getContainerById(item.element_id)
              if(container.loaded){
                item.name = container.name
              } else if(!containers.includes(item.element_id)){
                containers.push(item.element_id)
              }
            } else if(item.element_type==="post"){
              let post = this.getPostById(item.element_id)
              if(post.loaded){
                item.name = post.name
              } else if(!posts.includes(item.element_id)){
                posts.push(item.element_id)
              }
            }
          })
  
          if(posts.length>0 || containers.length>0){
            this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
              this.$store.commit('app/org/addPosts', response.posts_data)
              response.posts_data.map( post => {
                const index = this.statistic.scope.findIndex( el => el.element_id===post.id)
                if (index>=0) this.statistic.scope[index].name = post.name
              })
  
              this.$store.commit('app/org/addContainers', response.containers_data)
              response.containers_data.map( container => {
                const index = this.statistic.scope.findIndex( el => el.element_id===container.id)
                if (index>=0) this.statistic.scope[index].name = container.name
              })
            })
          }
          
        })
      },
      
      getTree(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
      },
      
  
      submitData(){
        let is_valid = true
        if(this.statistic.labels){
          this.statistic.labels.map( item => {
            if(item.series==='') is_valid=false
          })
        }
        if(is_valid){
          this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
          if(this.editMode){
            this.$store.dispatch('analytics_old/statistics/update', this.statistic).then( response => {
              this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.$emit('close-dialog')
            }).catch( error => {
              this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          } else {
            this.$store.dispatch('analytics_old/statistics/create', this.statistic).then( response => {
              this.$emit('close-dialog')
            }).catch( error => {
              this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          }
        } else {
          this.status={ btnDisabled: false, text: 'Нужно выбрать срез для всех показателей', className:'red--text darken-1' }
        }
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/ComplexStatisticForm.vue